/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetPressReleaseHistoryListSuccessResponseReleaseHistories,
    GetPressReleaseHistoryListSuccessResponseReleaseHistoriesFromJSON,
    GetPressReleaseHistoryListSuccessResponseReleaseHistoriesFromJSONTyped,
    GetPressReleaseHistoryListSuccessResponseReleaseHistoriesToJSON,
} from './GetPressReleaseHistoryListSuccessResponseReleaseHistories';

/**
 * GET /press_release/{release_id}/history
 * @export
 * @interface GetPressReleaseHistoryListSuccessResponse
 */
export interface GetPressReleaseHistoryListSuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof GetPressReleaseHistoryListSuccessResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof GetPressReleaseHistoryListSuccessResponse
     */
    message: string;
    /**
     * 
     * @type {Array<GetPressReleaseHistoryListSuccessResponseReleaseHistories>}
     * @memberof GetPressReleaseHistoryListSuccessResponse
     */
    releaseHistories: Array<GetPressReleaseHistoryListSuccessResponseReleaseHistories>;
}

export function GetPressReleaseHistoryListSuccessResponseFromJSON(json: any): GetPressReleaseHistoryListSuccessResponse {
    return GetPressReleaseHistoryListSuccessResponseFromJSONTyped(json, false);
}

export function GetPressReleaseHistoryListSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPressReleaseHistoryListSuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'releaseHistories': ((json['release_histories'] as Array<any>).map(GetPressReleaseHistoryListSuccessResponseReleaseHistoriesFromJSON)),
    };
}

export function GetPressReleaseHistoryListSuccessResponseToJSON(value?: GetPressReleaseHistoryListSuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'release_histories': ((value.releaseHistories as Array<any>).map(GetPressReleaseHistoryListSuccessResponseReleaseHistoriesToJSON)),
    };
}

